import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import '../styles/LoginNavbar.css';

const LoginNavbar = () => {
  return (
    <header className="global-public-header">
      <div className="global-public-header-inner">
        <Link to="/" className="global-public-brand">
          <img src="/Bandeira_do_Pará.svg.png" alt="Bandeira do Estado do Pará" className="navbar-bandeira" />
          <div className="global-public-brand-text">
            <div className="global-public-brand-title">ADEPARÁ</div>
            <div className="global-public-brand-subtitle">SISTEMA CDS</div>
          </div>
        </Link>
        <Link to="/user/login" className="global-public-login-btn">
          <Lock size={14} /> Login
        </Link>
      </div>
    </header>
  );
};

export default LoginNavbar;